import ApiService from "@/common/api.service";

import {
  // action types
  LOAD_DATA,
  // VIEW_RECORD,
  ADD_RECORD,
  GET_RECORD,
  UPDATE_RECORD,
  DELETE_RECORD,

  // mutation types
  SET_PAGE,
  SET_DATA,
  SET_ACTIVE_DATA,
  SET_ERROR,
  IS_LOADING
} from "@/consts";

const ENDPOINT = "admin/roles";

const state = {
  errors: null,
  records: [],
  pagination: {},
  activeRecord: {},
  isLoading: false
};

const getters = {
  getRecordsList(state) {
    return state.records;
  },
  getPagination(state) {
    return state.pagination;
  },
  getActiveRecord(state) {
    return state.activeRecord;
  },
  getErrors(state) {
    return state.errors;
  },
  isLoading(state) {
    return state.isLoading;
  }
};

const actions = {
  [LOAD_DATA](context, params) {
    return new Promise(resolve => {
      ApiService.query(ENDPOINT, params)
        .then(({ data }) => {
          context.commit(SET_DATA, data.data);
          context.commit(SET_PAGE, data.meta);
          resolve(data);
        })
        .catch(({ response }) => {
          if (response) {
            if (response.data.errors) {
              context.commit(SET_ERROR, response.data.errors);
            } else if (response.data.message) {
              if ([401, 403].indexOf(response.status) !== -1) {
                context.commit(SET_ERROR, ["Authentication Error!"]);
              } else {
                context.commit(SET_ERROR, [response.data.message]);
              }
            } else {
              context.commit(SET_ERROR, [
                "Server Error Occured: " + response.statusText
              ]);
            }
          } else {
            context.commit(SET_ERROR, ["An unknown Error Occured"]);
          }
        });
    });
  },
  [GET_RECORD](context, id) {
    return new Promise(resolve => {
      ApiService.query(`${ENDPOINT}/${id}`)
        .then(({ data }) => {
          context.commit(SET_ACTIVE_DATA, data.data);
          resolve(data);
        })
        .catch(({ response }) => {
          if (response) {
            if (response.data.errors) {
              context.commit(SET_ERROR, response.data.errors);
            } else if (response.data.message) {
              if ([401, 403].indexOf(response.status) !== -1) {
                context.commit(SET_ERROR, ["Authentication Error!"]);
              } else {
                context.commit(SET_ERROR, [response.data.message]);
              }
            } else {
              context.commit(SET_ERROR, [
                "Server Error Occured: " + response.statusText
              ]);
            }
          } else {
            context.commit(SET_ERROR, ["An unknown Error Occured"]);
          }
        });
    });
  },
  [ADD_RECORD](context, { form_data, commitData }) {
    return new Promise((resolve, reject) => {
      ApiService.post(ENDPOINT, form_data)
        .then(({ data }) => {
          if (commitData) {
            context.commit(SET_DATA, data.data);
          }

          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [UPDATE_RECORD](context, { recordId, form_data }) {
    return new Promise((resolve, reject) => {
      ApiService.put(`${ENDPOINT}/${recordId}`, form_data)
        .then(({ data }) => {
          context.commit(SET_ACTIVE_DATA, {});
          context.commit(UPDATE_RECORD, data);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, response.data.errors);
          reject(response);
        });
    });
  },
  [DELETE_RECORD](context, id) {
    return new Promise(resolve => {
      ApiService.delete(`${ENDPOINT}/${id}`)
        .then(({ data }) => {
          context.commit(DELETE_RECORD, id);
          return resolve(data);
        })
        .catch(({ response }) => {
          if (response) {
            if (response.data.errors) {
              context.commit(SET_ERROR, response.data.errors);
            } else if (response.data.message) {
              if ([401, 403].indexOf(response.status) !== -1) {
                context.commit(SET_ERROR, ["Authentication Error!"]);
              } else {
                context.commit(SET_ERROR, [response.data.message]);
              }
            } else {
              context.commit(SET_ERROR, [
                "Server Error Occured: " + response.statusText
              ]);
            }
          } else {
            context.commit(SET_ERROR, ["An unknown Error Occured"]);
          }
        });
    });
  }
};

const mutations = {
  [SET_ERROR](state, error) {
    state.errors = error;
  },
  [SET_DATA](state, payload) {
    state.records = payload;
    state.errors = {};
  },
  [SET_ACTIVE_DATA](state, payload) {
    const record =
      typeof payload == "number"
        ? state.records.filter(role => {
            return role.id === payload;
          })
        : payload;

    state.activeRecord =
      typeof record == "object" && record.length ? record[0] : record;
  },
  [UPDATE_RECORD](state, payload) {
    const indx = state.records.findIndex(data => {
      return data.id === payload.id;
    });

    if (indx > -1) {
      state.record[indx] = payload;
    }
  },
  [DELETE_RECORD](state, payload) {
    const indx = state.records.findIndex(data => {
      return data.id === payload;
    });

    if (indx > -1) {
      state.records.splice(indx, 1);
      state.pagination.total--;
      state.pagination.to--;
    }
  },
  [SET_PAGE](state, pageData) {
    state.pagination = pageData;
  },
  [IS_LOADING](state, payload) {
    state.isLoading = payload;
  }
};

const adminRoles = {
  namespaced: true,
  state: state,
  actions: actions,
  mutations: mutations,
  getters: getters
};

export default adminRoles;
